import { isGuideSupported } from "@expert/solve-tools";

interface OpenOnCallStartProps {
    disableAutomaticOpen: boolean;
    isCustomerSession: boolean;
    isGuideOpen: boolean;
    isLoadingSimplrSession: boolean;
    sessionId: string;
}
export function shouldOpenOnCallStart({
    disableAutomaticOpen,
    isCustomerSession,
    isGuideOpen,
    isLoadingSimplrSession,
    sessionId,
}: Readonly<OpenOnCallStartProps>) {
    const isADTGuideAvailable = isGuideSupported(sessionId, "ADT Guide");

    return isADTGuideAvailable && !isGuideOpen && isCustomerSession && !disableAutomaticOpen && !isLoadingSimplrSession;
}
